<template>
  <v-dialog v-model="dialogOpen" width="1000" @click:outside="close" persistent>

    <AuditTable :items="getCurrentAccountAuditG" :loading="currentAccountAuditLoading" :server-items-length="currentAccountAudit.config.paginationCount" @updatePagination="updatePagination" :reset="resetAuditTable">
      <template #title>Billing Account Audit</template>
    </AuditTable>

  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapGetters, mapMutations } from "vuex";

  import AuditTable from '@/components/Globals/AuditTable';

  export default {
    components: { AuditTable },

    props: ['dialogOpen'],

    data() {
      return {
        resetAuditTable: false
      }
    },

    computed: {
      ...mapState('accounts',['currentAccountAudit','currentAccountAuditLoading']),
      ...mapGetters('accounts',['getCurrentAccountAuditG']),
    },

    watch: {
      async dialogOpen(val) {
        if (val) {
          this.resetAuditTable = false;
          await this.fetchCurrentAccountAudit(this.$route.params.id);
        }
      }
    },

    methods: {
      ...mapMutations('accounts', ['RESET_CURRENTACCOUNT_AUDIT']),
      ...mapActions('accounts',['updateCurrentAccountAuditPagination','fetchCurrentAccountAudit']),

      updatePagination(options) {
        this.updateCurrentAccountAuditPagination({ id:this.$route.params.id, options });
      },

      resetTable() {
        this.resetAuditTable = true;
        this.RESET_CURRENTACCOUNT_AUDIT();
      },

      close() {
        this.resetTable();
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped></style>
